<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h12">Acknowledgments</h1>
<p class="p1"><span class="t4"><img alt="img5.png" src="Images/img5.png"/></span></p>
<p><span class="t4"> </span></p>
<p><span class="t4">Many thanks to Elizabeth and DSP Publications for their support. Great thanks and cookies for Lynn and Ione and the rest of the editors for helping me polish my novel and the patience they have shown me. Any mistakes made are mine and not theirs.</span></p>
<p><span class="t4">Thanks and wine to Ed for betaing my work and all the strange looks he gets on the train when he does it. For Tim and Mark and Ed, for letting me hash out plot details over our weekly dinners.</span></p>
<p><span class="t4">And for my sister Su-Su, who has put up with all the teasing we do with her about Mason and her great fondness for the man.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006.vue?eff132ca